import React, { useEffect } from "react";
import styles from "./styles.css";
import PropTypes from "prop-types";
import LuxuryCarsHomeBanner from "../luxury-car-home-banner";
import { C2B_LEAD_TYPES } from "../../../constants/seller-lead-types";
import SellUsedLuxuryMetaTags from "../../shared/sell-used-luxury-cars";
import { Helmet } from "react-helmet-async";
import { appUrl } from "../../../constants/url-constants";
import ElitePageLayout from "../elite-page-layout";

const SellUsedLuxuryCars = ({ cmsData, isSSR, fetchLuxuryPageDataConnect, updateLeadSourceConnect, history }) => {

    const metaTitle = cmsData?.seo?.title;
    const metaDescription = cmsData?.seo?.description;

    useEffect(() => {
        updateLeadSourceConnect(C2B_LEAD_TYPES.SEO_LUXURY);
        if (!isSSR) {
            fetchLuxuryPageDataConnect();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isSSR]);

    return (
        <>
            <Helmet>
                <link href={`${appUrl()}${history.location.pathname.replace(/\/$/, "")}/`} rel="canonical" />
            </Helmet>
            <SellUsedLuxuryMetaTags
                metaTitle={metaTitle}
                metaDescription={metaDescription}
                ogTitle = {metaTitle}
                ogDescription = {metaDescription}
            />
            <LuxuryCarsHomeBanner />
            <ElitePageLayout/>
        </>
    );
};

SellUsedLuxuryCars.propTypes = {
    isSSR: PropTypes.bool,
    fetchLuxuryPageDataConnect: PropTypes.func,
    cmsData: PropTypes.object,
    updateLeadSourceConnect: PropTypes.func,
    history: PropTypes.object
};

export default SellUsedLuxuryCars;
